import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import Slide from '@material-ui/core/Slide';

import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import PublicOutlinedIcon from '@material-ui/icons/PublicOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';

const useStyles = makeStyles((theme) => ({

    menuPaper: {
        width: '85%',
        [theme.breakpoints.up('sm')]: {
            width: '40%',
        },
        [theme.breakpoints.up('md')]: {
            width: '20%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '15%',
        },
        marginTop: '0.60rem',
        borderTop: 'none',
        border: '1px solid #858585',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        transition: 'none',
    },
    menuItem: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingRight: '32px',
        paddingLeft: '32px',
    },
    divider: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    menuAvatar: {
        marginLeft: theme.spacing(1),
        border: '2px solid #E0E0E0',
    },
    simpleItem: {
        paddingTop: theme.spacing(1),
    },
    simpleItemIcon: {
        fill: '#404040',
        marginRight: '10px',
        marginLeft: theme.spacing(1),
    }

}));

export const AccountMenu = (props) => {

    const { anchor, handleSwitchOrganisation, handleCloseMenu, handleLogout, config } = props;
    const { organisation, organisations, loading } = props.useProfileState();
    const classes = useStyles();
    const [organisationsList, setOrganisationsList] = useState([]);

    useEffect(() => {
        if (organisation && organisations && !loading) {
            processAccounts(organisations)
        }
    }, [organisation, organisations, loading])

    const processAccounts = (organisations) => {
        var localOrganisations = [...organisations];
        var removeIndex = localOrganisations.findIndex(org => org.id === organisation.id)
        delete localOrganisations[removeIndex];
        setOrganisationsList(localOrganisations);
    }

    const switchOrganisation = (oid) => {
        handleSwitchOrganisation(oid)
        handleCloseMenu()
    }

    const handleManageOrganisation = () => {
        window.location.replace(`${config.accountUrl}/organisation/manage`);
    };

    const handleUserSettings = () => {
        window.location.replace(`${config.accountUrl}/user`);
    }

    return (
        <Slide direction="down" style={{ zIndex: 1200 }} timeout={500} in={Boolean(anchor)}>
            <Menu
                id="userMenu"
                elevation={3}
                anchorEl={anchor}
                keepMounted
                open={Boolean(anchor)}
                onClose={handleCloseMenu}
                getContentAnchorEl={null}
                classes={{ paper: classes.menuPaper }}
                disableAutoFocusItem
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 256,
                }}
            >
                {
                    organisationsList.map((organisation, i) => {
                        return (
                            <MenuItem
                                key={i}
                                className={classes.menuItem}
                                onClick={() => switchOrganisation(organisation.id)}
                            >
                                {organisation.organisationName}
                                <Avatar src={`${config.cdnUrl}/images/avatars/${organisation.id}`} className={classes.menuAvatar}>
                                    <AccountBalanceOutlinedIcon />
                                </Avatar>
                            </MenuItem>
                        );
                    })
                }
                <Divider className={classes.divider} />
                <MenuItem
                    onClick={handleManageOrganisation}
                    className={clsx(classes.menuItem, classes.simpleItem)}
                >
                    Manage Organisations
                    <AccountBalanceOutlinedIcon className={classes.simpleItemIcon} />
                </MenuItem>
                <MenuItem
                    onClick={handleUserSettings}
                    className={clsx(classes.menuItem, classes.simpleItem)}
                >
                    User Settings
                    <SettingsOutlinedIcon className={classes.simpleItemIcon} />
                </MenuItem>
                <MenuItem
                    onClick={handleLogout}
                    className={clsx(classes.menuItem, classes.simpleItem)}
                >
                    Logout
                    <PublicOutlinedIcon className={classes.simpleItemIcon} />
                </MenuItem>
            </Menu>
        </Slide>
    );
}